import { Spinner, SpinnerSize } from "@fluentui/react";
import React from "react";
import { language } from "../../Services/LocalizationService";

export const PFSpinner = (props: { LabelText?: string, CustomClass?: string }) => <Spinner size={ SpinnerSize.large } label={ props.LabelText ?? language.Common.LoadingDot } className={`${props.CustomClass ? "customClass" : "tp-spinner"}`} />